import { clock, duration, fullTime } from "../lib/format.ts";
import { toolLabel, type ToolCallView } from "../lib/transcript.ts";

function statusIcon(c: ToolCallView) {
  if (!c.result) return <span className="spinner" style={{ width: 12, height: 12 }} aria-label="running" />;
  return c.result.isError ? <span style={{ color: "var(--bad)" }}>✖</span> : <span style={{ color: "var(--ok)" }}>✓</span>;
}

/** One expandable row per tool call: what it did, how it went, the full input and output. */
export function ToolRow({ call, showTime }: { call: ToolCallView; showTime?: boolean }) {
  const took = call.result ? Date.parse(call.result.at) - Date.parse(call.at) : null;
  return (
    <details>
      <summary className="toolrow">
        {statusIcon(call)}
        <span className="ellipsis">
          <span className="name">{call.name}</span> <span className="arg">{toolLabel(call)}</span>
        </span>
        <span className="muted small nowrap" title={fullTime(call.at)}>
          {showTime && clock(call.at)}
          {took !== null && took > 1500 ? ` · ${duration(took)}` : ""}
        </span>
      </summary>
      <div className="stack tight" style={{ margin: "6px 0 10px 26px" }}>
        <pre className="small">
          <code>{JSON.stringify(call.input, null, 2)}</code>
        </pre>
        {call.result && (
          <pre className="small" style={call.result.isError ? { background: "var(--bad-soft)" } : undefined}>
            <code>{call.result.text.length > 20_000 ? `${call.result.text.slice(0, 20_000)}\n… (cut)` : call.result.text || "(no output)"}</code>
          </pre>
        )}
      </div>
    </details>
  );
}

export function Timeline({ tools }: { tools: ToolCallView[] }) {
  if (!tools.length) return <div className="empty">No tool calls yet.</div>;
  return (
    <div className="card">
      <div className="stack tight">
        {tools.map((c) => (
          <ToolRow key={c.id} call={c} showTime />
        ))}
      </div>
    </div>
  );
}
